// eslint-disable-next-line
import { German } from 'flatpickr/dist/l10n/de';

export default {
  dateConfig: {
    disableMobile: true,
    altInput: true,
    altFormat: 'd-m-Y H:i',
    dateFormat: 'Y-m-d H:i:S',
    locale: German,
    enableTime: true,
  },
  dateConfigSimple: {
    disableMobile: true,
    altInput: true,
    altFormat: 'd-m-Y',
    dateFormat: 'Y-m-d',
    locale: German,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/state.js